import { render, staticRenderFns } from "./NumberAllocationForm.vue?vue&type=template&id=0802f96b"
import script from "./NumberAllocationForm.vue?vue&type=script&lang=js"
export * from "./NumberAllocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports